import React, { useEffect, useState } from "react";
import styles from "./Hero.module.css";
import { Stat, AnimatedStat } from "../../types";

interface HeroProps {
  title: string;
  subtitle: string;
  ctaText: string;
  stats: Stat[];
}

const Hero: React.FC<HeroProps> = ({ title, subtitle, ctaText, stats }) => {
  const [animatedStats, setAnimatedStats] = useState<AnimatedStat[]>(
    stats.map((stat) => ({ ...stat, animatedNumber: "0" })),
  );

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Animate stats
            stats.forEach((stat, index) => {
              const target = parseInt(stat.number);
              let current = 0;
              const increment = target / 50;
              const timer = setInterval(() => {
                current += increment;
                if (current >= target) {
                  current = target;
                  clearInterval(timer);
                }
                setAnimatedStats((prev) => {
                  const newStats = [...prev];
                  newStats[index] = {
                    ...newStats[index],
                    animatedNumber: Math.round(current).toString(),
                  };
                  return newStats;
                });
              }, 30);
            });
            observer.disconnect();
          }
        });
      },
      { threshold: 0.5 },
    );

    const heroSection = document.querySelector("#home");
    if (heroSection) {
      observer.observe(heroSection);
    }

    return () => observer.disconnect();
  }, [stats]);

  const handleCTAClick = () => {
    const element = document.querySelector("#services");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section id="home" className={styles.hero}>
      <div className="container">
        <div className={styles.heroContent}>
          <h1
            className={styles.title}
            dangerouslySetInnerHTML={{ __html: title }}
          />
          <p className={styles.description}>{subtitle}</p>
          <button onClick={handleCTAClick} className={styles.ctaButton}>
            {ctaText}
          </button>

          <div className={styles.heroStats}>
            {animatedStats.map((stat) => (
              <div key={stat.id} className={styles.heroStat}>
                <div className={styles.heroStatNumber}>
                  {stat.animatedNumber}
                </div>
                <div className={styles.heroStatLabel}>{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
